import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import MuiCardContent, {
  CardContentProps,
} from '@material-ui/core/CardContent';

const CardContent: React.FC<CardContentProps> = withStyles((theme) => ({
  root: {
    padding: theme.spacing(1, 0.5),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
  },
}))(MuiCardContent);

export default CardContent;
